import * as React from 'react';
import { lazy, Suspense } from 'react';

// Dynamically import the PDF component to split the bundle
const PDFViewComponent = lazy(() => import('./PDFView').then((module) => ({ default: module.PDFView })));

interface Props {
  url: string;
  width: number;
}

// Loading component while PDF library loads
const PDFLoadingFallback: React.FC = () => (
  <div className='flex items-center justify-center rounded-lg bg-gray-50 p-8'>
    <div className='flex flex-col items-center space-y-4'>
      <div className='h-8 w-8 animate-spin rounded-full border-b-2 border-gray-600'></div>
      <p className='text-sm text-gray-600'>Loading PDF viewer...</p>
    </div>
  </div>
);

export const PDFLoader: React.FC<React.PropsWithChildren<Props>> = ({ url, width }) => {
  return (
    <Suspense fallback={<PDFLoadingFallback />}>
      <PDFViewComponent url={url} width={width} />
    </Suspense>
  );
};
